/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Profile
} from '../../schema'


/**
 * List all profiles
 */
export const listProfiles = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Profile[]>> => {
    return axios.get(
      `/profiles/`,options
    );
  }


export const getListProfilesQueryKey = () => [`/profiles/`];

    
export type ListProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listProfiles>>>
export type ListProfilesQueryError = AxiosError<unknown>

export const useListProfiles = <TData = Awaited<ReturnType<typeof listProfiles>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProfiles>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProfilesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfiles>>> = ({ signal }) => listProfiles({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listProfiles>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create a profile
 */
export const createProfile = (
    profile: Profile, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Profile>> => {
    return axios.post(
      `/profiles/`,
      profile,options
    );
  }



    export type CreateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createProfile>>>
    export type CreateProfileMutationBody = Profile
    export type CreateProfileMutationError = AxiosError<unknown>

    export const useCreateProfile = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: Profile}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProfile>>, {data: Profile}> = (props) => {
          const {data} = props ?? {};

          return  createProfile(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createProfile>>, TError, {data: Profile}, TContext>(mutationFn, mutationOptions)
    }
    